import { render, staticRenderFns } from "./magazineTab.vue?vue&type=template&id=7ca799b4&"
import script from "./magazineTab.vue?vue&type=script&lang=js&"
export * from "./magazineTab.vue?vue&type=script&lang=js&"
import style0 from "./magazineTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports